import useAxiosPublicInstance from "@/hooks/useAxiosPublicInstance";
import { useEffect, useState } from "react";

export default function useFetchEvents(data) {
  // const axiosPublicInstance = useAxiosPublicInstance();
  const [allEvents, setAllEvents] = useState(data);
  const [displayedEvents, setDisplayedEvents] = useState(data);
  // const [isLoading, setIsLoading] = useState(false);

  // useEffect(() => {
  //   async function fetchData() {
  //     setIsLoading(true);
  //     try {
  //       const { data } = await axiosPublicInstance.get(
  //         "/websiteContents/allEvent"
  //       );
  //       setAllEvents(data);
  //       setDisplayedEvents(data);
  //       setIsLoading(false);
  //     } catch (error) {
  //       setIsLoading(false);
  //     }
  //   }
  //   fetchData();
  // }, []);

  return {
    allEvents,
    displayedEvents,
    // isLoading,
    setDisplayedEvents,
    setAllEvents,
  };
}
